import { render, staticRenderFns } from "./QichachaDetails.vue?vue&type=template&id=e023d952&scoped=true&"
import script from "./QichachaDetails.vue?vue&type=script&lang=js&"
export * from "./QichachaDetails.vue?vue&type=script&lang=js&"
import style0 from "./QichachaDetails.vue?vue&type=style&index=0&id=e023d952&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e023d952",
  null
  
)

export default component.exports